import styled from 'styled-components';

export const EditCell = styled.input`
  padding: 10px;
  margin: 0;
  border: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  font-family: Verdana, Arial, Helvetica, sans-serif;
  resize: none;
  overflow: hidden;
  height: auto;
  font-size: inherit;
`;
